// Campaign themes. Each key needs a matching palette in
// src/assets/scss/layouts/_themes.scss and an option in the Dato "theme"
// (landing page) and "productTheme" (promotion) fields.
export const campaignThemes = ["black-friday"]

// Turns a Dato option into a theme key, e.g. "Black Friday" -> "black-friday".
// "None" and unknown values give no theme.
export const toThemeKey = value => {
  const key = value
    ?.trim()
    .toLowerCase()
    .replace(/\s+/g, "-")
  return campaignThemes.includes(key) ? key : null
}
